var map = {
	"./1hanami-logo.png": 695,
	"./hanami-logo-512.png": 1966,
	"./hanami-logo.png": 6259,
	"./icon/clippy.svg": 659,
	"./landing/p3.svg": 3763,
	"./logo/betterdev.png": 5939,
	"./logo/bookmark.png": 9708,
	"./logo/ec2.svg": 858,
	"./logo/flowingpage.png": 1924,
	"./logo/hanami.png": 8544,
	"./logo/lapa.png": 465,
	"./logo/run.png": 9817,
	"./logo/thumb-up.png": 3058,
	"./support/problem.jpg": 5479,
	"./support/rock.jpg": 3595,
	"./support/wood.jpg": 5423
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4550;